import { tryJsonParse } from '@blockworks/platform';

import { ValidationError } from '../workflows/validation';

enum VisualizationErrorType {
    Schema = 'schema',
    Configuration = 'configuration',
    Execution = 'execution',
    Worker = 'worker',
}

enum VisualizationErrorVersion {
    V1 = 'v1',
    V2 = 'v2',
}

export const parseStringError = (message: string) => {
    const messageParsed = tryJsonParse(message);
    if (
        messageParsed.isJsonString &&
        'version' in messageParsed.parsedJson &&
        messageParsed.parsedJson.version === VisualizationErrorVersion.V2
    ) {
        return messageParsed.parsedJson as { version: VisualizationErrorVersion.V2; errors: ValidationError[] };
    }
    return { version: VisualizationErrorVersion.V1, message } as const;
};

class VisualizationError extends Error {
    type: string;
    message: string;
    queryId?: string;
    visualizationId?: string;
    executionId?: string;
    details?: any[];
    constructor(props: {
        type: VisualizationErrorType;
        message: string;
        queryId?: string;
        visualizationId?: string;
        executionId?: string;
        details?: any[];
    }) {
        super();
        this.type = props.type;
        this.message = props.message;
        this.queryId = props.queryId;
        this.visualizationId = props.visualizationId;
        this.executionId = props.executionId;
        this.details = props.details;
    }
}

export { VisualizationError, VisualizationErrorVersion, VisualizationErrorType };
